// Filename - useCountdownTimer.js

import { useState, useEffect, useRef } from "react";

const useCountdownSecondsTimer = (initialTimeInSeconds) => {
  const [formattedTimer, setFormattedTimer] = useState("");
  const [remainingSeconds, setRemainingSeconds] = useState(initialTimeInSeconds);
  const timerRef = useRef(null);

  const getTimeRemaining = (endTime) => {
    const total = endTime - Date.parse(new Date());
    const seconds = Math.floor(total / 1000);
    return {
      total,
      seconds,
    };
  };

  const startTimer = (endTime) => {
    const { total, seconds } = getTimeRemaining(endTime);
    if (total >= 0) {
      setFormattedTimer(`${seconds}`);
      setRemainingSeconds(seconds);
    }
  };

  const clearTimer = (endTime) => {
    if (timerRef.current) clearInterval(timerRef.current);
    const id = setInterval(() => {
      startTimer(endTime);
    }, 1000);
    timerRef.current = id;
  };

  useEffect(() => {
    const endTime = new Date();
    endTime.setSeconds(endTime.getSeconds() + initialTimeInSeconds);
    clearTimer(endTime);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [initialTimeInSeconds]); // eslint-disable-line react-hooks/exhaustive-deps

  const resetTimer = () => {
    const endTime = new Date();
    endTime.setSeconds(endTime.getSeconds() + initialTimeInSeconds);
    clearTimer(endTime);
  };

  return { formattedTimer, remainingSeconds, resetTimer };
};

export default useCountdownSecondsTimer;
